import { useApiMutation, useInvalidateQueries } from '@/shared/hooks/useApi';
import { api } from '@/shared/services/api';

import { AddAddressRequest, UpdateAddressRequest } from '../types/userTypes';

export const useAddressMutations = (userUuid: string) => {
  const { invalidateQueries } = useInvalidateQueries();

  const addAddressMutation = useApiMutation<null, Error, AddAddressRequest>(
    (addressData) =>
      api.post<null>(`/api/v1/user/address/${userUuid}`, addressData),
    {
      onSuccess: () => {
        invalidateQueries(['user', 'detail', userUuid]);
      },
      onError: (error: any) => {
        alert(`Failed to add address: ${error?.message || 'Unknown error'}`);
      },
    },
  );

  const updateAddressMutation = useApiMutation<
    null,
    Error,
    { addressUuid: string; addressData: UpdateAddressRequest }
  >(
    ({ addressUuid, addressData }) =>
      api.patch<null>(
        `/api/v1/user/address/${userUuid}/${addressUuid}`,
        addressData,
      ),
    {
      onSuccess: () => {
        invalidateQueries(['user', 'detail', userUuid]);
      },
      onError: (error: any) => {
        alert(`Failed to update address: ${error?.message || 'Unknown error'}`);
      },
    },
  );

  return {
    addAddress: (addressData: AddAddressRequest) => {
      addAddressMutation.mutate(addressData);
    },
    updateAddress: (addressUuid: string, addressData: UpdateAddressRequest) => {
      updateAddressMutation.mutate({ addressUuid, addressData });
    },
    isAddingAddress: addAddressMutation.isPending,
    isUpdatingAddress: updateAddressMutation.isPending,
    addAddressError: addAddressMutation.error,
    updateAddressError: updateAddressMutation.error,
  };
};
